import { Select as AntSelect } from 'antd';

const AntOption = AntSelect.Option;

export const Option = AntOption;

export const Select = AntSelect;
